module.exports = __webpack_public_path__ + "static/media/1.23e601c5.svg";